module.exports = __webpack_public_path__ + "d7a4d80e91d3757883417a799a37d3ff.svg";